const actionTypeIdentifier = 'BA26A9DF-C030 -4FAB -8D1B -3AFFA8D2564C'

export const setDefaultManageUser = `SET-DEFAULT-MANAGE-USER-${actionTypeIdentifier}`;
export const getManageUser = `GET-MANAGE-USER-${actionTypeIdentifier}`;
export const setManageUserError = `SET-MANAGE-USER-${actionTypeIdentifier}`;
export const setManageUserColSearchStr = `SET-MANAGE-USER-COL-SEARCH-STR-${actionTypeIdentifier}`;
export const sortManageUserList = `SORT-MANAGE-USER-LIST-${actionTypeIdentifier}`;
export const setManageUserListPageSizes = `SET-MANAGE-USER-LIST-PAGE-SIZES${actionTypeIdentifier}`;
export const setManageUserFilter = `SET-MANAGE-USER-FILTER${actionTypeIdentifier}`;
export const applyManageUserFilter = `APPLY-MANAGE-USER-FILTER${actionTypeIdentifier}`;